<template>
    <DModal
        v-if="userPermissions.includes('user.create')"
        :show="showModal"
        :title="__('users.create.modal.add')"
        is-confirm
        :confirm-button-text="__('users.create.modal.create')"
        is-big
        :is-awaiting-validation="true"
        @confirm="createUserConfirm"
        @close="$emit('close-modal')"
    >
        <DAlert
            color="warning"
            class="d-flex align-items-center"
        >
            <DIcon
                name="alert"
                :size="24"
            />
            <div class="pr-2">
                {{ __('users.create.messages.warning') }}
            </div>
        </DAlert>
        <DForm>
            <DCard
                padding
            >
                <DFormRow
                    :label="__('users.create.modal.form.name')"
                >
                    <DInput
                        id="user-name"
                        v-model="form.name"
                        :placeholder="__('users.create.modal.form.name')"
                        requried
                        :invalid-feedback="errorsData.name"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('users.create.modal.form.email')"
                >
                    <DInput
                        id="user-email"
                        v-model="form.email"
                        :placeholder="__('users.create.modal.form.email')"
                        requried
                        :invalid-feedback="errorsData.email"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('users.create.modal.form.password')"
                >
                    <DInput
                        id="user-password"
                        v-model="form.password"
                        :placeholder="__('users.create.modal.form.password')"
                        requried
                        :invalid-feedback="errorsData.password"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('users.create.modal.form.select_role')"
                >
                    <DSelect
                        id="user-role"
                        :placeholder="__('users.create.modal.form.select_role')"
                        add-label-classes="required"
                        :options="roles"
                        :invalid-feedback="errorsData.role"
                        @update:value="updateSelectedRole"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('users.edit.form.display_name')"
                >
                    <DInput
                        id="display-name"
                        v-model="form.displayName"
                        :invalid-feedback="errorsData.displayName"
                    />
                </DFormRow>
            </DCard>
        </DForm>
    </DModal>
</template>

<script setup>

import { useForm, usePage } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { computed, ref } from 'vue'

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    },
    roles: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

const form = useForm({
    name: null,
    email: null,
    password: null,
    role: null,
    roleName: '',
    displayName: null
})

const errorsProps = ref(props.errors)

let errorsData = errorsProps.value

const emit = defineEmits(['close-modal'])
const userPermissions = computed(() => usePage().props.auth.permissions)
const updateSelectedRole = (value) => {
    form.role = value
}

function createUserConfirm () {
    const role = props.roles.find((role) => role.value === parseInt(form.role))
    form.roleName = role?.label ?? ''

    form.post(route('users.store', {
        name: form.name,
        email: form.email,
        password: form.password,
        roleName: form.roleName,
        displayName: form.displayName
    }), {
        onSuccess: () => {
            emit('close-modal', form)
        },
        onError: (error) => {
            errorsData = error
        }
    })
}

</script>

<style scoped lang="scss">

</style>
